import React from 'react';

import classes from './TextSpinner.scss';

const textSpinner = (props) => {
    let spinnerClass = [classes.Spinner];

    if (props.type === 'Dark') {
        spinnerClass.push(classes.Dark);
    } else if (props.type === 'Light') {
        spinnerClass.push(classes.Light);
    } else if (props.type === 'White') {
        spinnerClass.push(classes.White);
    }

    return (
        <span className={spinnerClass.join(' ')}>
            <span className={classes.Bounce1}></span>
            <span className={classes.Bounce2}></span>
            <span className={classes.Bounce3}></span>
        </span>
    );
}

export default textSpinner;


// WEBPACK FOOTER //
// ./src/components/UI/TextSpinner/TextSpinner.js